import React from "react";
import { NavLink, Outlet } from "react-router-dom";

const PropertyLayout = () => {
  React.useEffect(() => {
    document.body.style.overflow = "hidden";
    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);
  return (
    <div>
      <Outlet />
    </div>
  );
};

export default PropertyLayout;
